import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'showWorkflowIconPipe'
})
export class ShowWorkflowIconPipePipe implements PipeTransform {

  transform(value: any, isShowWFIcon?: boolean,enableRowWiseWFIcon?: boolean,isShowStartWF?: boolean): any {
      if (value.approved_Tag == false && value.approved_On == null)
        return false;
      else
        return isShowWFIcon && enableRowWiseWFIcon && isShowStartWF && value.is_Latest && (!value.is_WF_Started || (value.is_WF_Started && value.can_Restart_WF))

  }

}
